<!-- <div> -->
  <form  [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">

    <div class="modal-header">
      <div class="title">
        <h2 class="modal-title-prefix"><span translate="KOMITENT.UVOZNBS.SINGULAR"></span></h2>
      </div>
      <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
    </div>
    <div class="modal-body">
      <div class="row">
          <div class="col-md-6">
              <div class="form-group row">
                  <div class="col-md-12">
                      <yt-input
                      [Type]="'text'"
                      name="txtNaziv"
                      formControlName="Naziv"
                      #focusElement
                      [MaxLength]="200"
                      [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
                      [Label]="'FIRMA.NAZIV.SINGULAR'"
                      #autofocus>
                    </yt-input>
                      <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                        <span *ngFor="let validation of errorMessages.Naziv">
                          <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                        </span>
                      </div>
                  </div>
              </div>
          </div>     
          <div class="col-md-6">
              <div class="form-group row">
                  <div class="col-md-12">
                      <yt-input
                      [Type]="'text'"
                      name="txtSNaziv"
                      formControlName="SNaziv"
                      #focusElement
                      [MaxLength]="200"
                      [ngClass]="{'is-invalid': submitted && fc.SNaziv.invalid}"
                      [Label]="'FIRMA.SNAZIV.SINGULAR'"
                      >
                    </yt-input>
                      <div class="form-error" *ngIf="submitted && fc.SNaziv.invalid">
                        <span *ngFor="let validation of errorMessages.SNaziv">
                          <span class="error-message" *ngIf="fc.SNaziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                        </span>
                      </div>
                  </div>
              </div>
          </div>            
      </div>
      <div class="row">
          <div class="col-md-6">
              <div class="form-group row">
                  <div class="col-md-12">
                      <yt-input
                      [Type]="'text'"
                      name="txtPib"
                      formControlName="Pib"
                      #focusElement
                      [MaxLength]="200"
                      [ngClass]="{'is-invalid': submitted && fc.Pib.invalid}"
                      [Label]="'FIRMA.PIB.SINGULAR'"
                      >
                    </yt-input>
                      <div class="form-error" *ngIf="submitted && fc.Pib.invalid">
                        <span *ngFor="let validation of errorMessages.Pib">
                          <span class="error-message" *ngIf="fc.Pib.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                        </span>
                      </div>
                  </div>
              </div>
          </div>     
          <div class="col-md-6">
              <div class="form-group row">
                  <div class="col-md-12">
                      <yt-input
                      [Type]="'text'"
                      name="txtMaticniBroj"
                      formControlName="MaticniBroj"
                      #focusElement
                      [MaxLength]="200"
                      [ngClass]="{'is-invalid': submitted && fc.MaticniBroj.invalid}"
                      [Label]="'FIRMA.MATICNIBROJ.SINGULAR'"
                      >
                    </yt-input>
                      <div class="form-error" *ngIf="submitted && fc.MaticniBroj.invalid">
                        <span *ngFor="let validation of errorMessages.MaticniBroj">
                          <span class="error-message" *ngIf="fc.MaticniBroj.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                        </span>
                      </div>
                  </div>
              </div>
          </div>            
      </div>
      <div class="row">
          <div class="col-md-6">
              <div class="form-group row">
                  <div class="col-md-12">
                      <yt-input
                      [Type]="'text'"
                      name="txtAdresa"
                      formControlName="Adresa"
                      #focusElement
                      [MaxLength]="200"
                      [ngClass]="{'is-invalid': submitted && fc.Adresa.invalid}"
                      [Label]="'FIRMA.ADRESA.SINGULAR'"
                      >
                    </yt-input>
                      <div class="form-error" *ngIf="submitted && fc.Adresa.invalid">
                        <span *ngFor="let validation of errorMessages.Adresa">
                          <span class="error-message" *ngIf="fc.Adresa.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                        </span>
                      </div>
                  </div>
              </div>
          </div>     
          <div class="col-md-6">
              <div class="form-group row">
                  <div class="col-md-12">
                      <yt-autocomplete
                        [ModelName]="'mesto'"
                        [GetName]="'getByNaziv'"
                        [ModelProperty]="'Naziv'"
                        [OrderBy]="'Naziv'"
                        [Label]="'FIRMA.MESTO.SINGULAR'"
                        formControlName="MestoID">
                      </yt-autocomplete>
                      <div class="form-error" *ngIf="submitted && fc.MestoID.invalid">
                        <span *ngFor="let validation of errorMessages.MestoID">
                          <span class="error-message" *ngIf="fc.MestoID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                        </span>
                      </div>
                  </div>
              </div>
          </div>            
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="form-group row">
            <div class="col-md-12">
                <yt-input
                [Type]="'text'"
                name="txtWeb"
                formControlName="Web"
                #focusElement
                [MaxLength]="200"
                [Label]="'FIRMA.WEB.SINGULAR'"
                >
              </yt-input>
            </div>
        </div>
        </div>     
        <div class="col-md-4">
          <div class="form-group row">
            <div class="col-md-12">
              <yt-dropdown-picklist
                [ModelName]="'language'"
                [GetName]="'get'"
                [ModelProperty]="'Name'"
                [OrderBy]="'Name'"
                [AllowAddNew]="false"
                formControlName="LanguageID"
                [Label]="'FIRMA.LANGUAGE.SINGULAR'"
                >
              </yt-dropdown-picklist>
              <div class="form-error" *ngIf="submitted && fc.LanguageID.invalid">
                <span *ngFor="let validation of errorMessages.LanguageID">
                  <span class="error-message" *ngIf="fc.LanguageID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
            </div>
        </div>
        </div> 
        <div class="col-md-4">
          <div class="form-group row">
            <div class="col-md-12">
                <yt-input
                [Type]="'text'"
                name="txtJbkjs"
                formControlName="Jbkjs"
                #focusElement
                [MaxLength]="5"
                [Label]="'FIRMA.JBKJS.SINGULAR'"
                >
              </yt-input>
              <div class="form-error" *ngIf="submitted && fc.Jbkjs.invalid">
                <span *ngFor="let validation of errorMessages.Jbkjs">
                  <span class="error-message" *ngIf="fc.Jbkjs.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
              </div>
            </div>
          </div>
        </div>           
    </div>

    <div class="row">   
      <div class="col-md-4 col-6">
        <div class="form-group row">
          <div class="col-md-12 col-12">
           <yt-dropdown-picklist 
            [ModelName]="'valuta'" 
            [GetName]="'get'" 
            [ModelProperty]="'Naziv,Sifra,ISOAlpha3Code'" 
            [OrderBy]="'Naziv'"
            [AllowAddNew]="false" 
            formControlName="ValutaID" 
            [Label]="'FIRMA.VALUTA.SINGULAR'"
            [Width]="'l'"
            [Position]="'left'"
            [FilterByAllColumns]="false"
            >
          </yt-dropdown-picklist>
          </div>
        </div>
      </div>        
  </div>

      

      <div class="row" style="height: 2rem" *ngIf = "emaili !== null"></div>

      <div class="form-group row">
        <div class="col-md-12">
          <yt-fw-grid-with-editing
            *ngIf = "emaili !== null"
            [Items]="emaili"
            [GridTableColumns]="gridEmailColumns"  
            formControlName = "EmailControl"    
            >
          </yt-fw-grid-with-editing> 
          <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
            <span class="error-message" *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkGrid && !this.baseFormGroup.errors.checkGrid.valid"><span translate="{{this.baseFormGroup.errors.checkGrid.message}}"></span></span>
          </div>
        </div>
      </div>

      <div class="row" style="height: 2rem" *ngIf = "telefoni !== null"></div>
 
      <div class="form-group row">
          <div class="col-md-12">
            <yt-fw-grid-with-editing
              *ngIf = "telefoni !== null"
              [Items]="telefoni"
              [GridTableColumns]="gridTelefonColumns"  
              formControlName = "TelefonControl"    
              >
            </yt-fw-grid-with-editing> 
            <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
              <span class="error-message" *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkGrid && !this.baseFormGroup.errors.checkGrid.valid"><span translate="{{this.baseFormGroup.errors.checkGrid.message}}"></span></span>
            </div>
          </div>
      </div>
  
      <div class="row" style="height: 2rem" *ngIf = "ziroracuni !== null"></div>

        <div class="form-group row">
            <div class="col-md-12">
              <yt-fw-grid-with-editing
                *ngIf = "ziroracuni !== null"
                [Items]="ziroracuni"
                [GridTableColumns]="gridZiroracunColumns"  
                formControlName = "ZiroracunControl"    
                >
              </yt-fw-grid-with-editing> 
              <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                <span class="error-message" *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkGrid && !this.baseFormGroup.errors.checkGrid.valid"><span translate="{{this.baseFormGroup.errors.checkGrid.message}}"></span></span>
              </div>
            </div>
          </div>
       

          <!-- <div class="row" style="height: 2rem" *ngIf="loading">
              <span class="loader"><span class="fa fa-spinner fa-spin"></span></span>
          </div> -->

      </div>

      <div class="form-group modal-footer">
        <button type="submit" class="btn btn-primary" id="btnSave" (click)="Save()">
          <span>Sačuvaj </span>
          <span *ngIf="loading" class="loader"><span class="fa fa-spinner fa-spin"></span></span>
        </button>
        <button type="button" class="btn btn-secondary" id="btnClose" (click)="Close()"><span>Zatvori</span></button>
      </div>
    </form>
    <!-- </div> -->